import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

function AnimalGoat() {
  return (
    <ItemPresenter imagePath={"/images/animals/goat.png"} bottomLabel={"Cabra"}
      customImageWidth={" "}
      />
  );
}

export default AnimalGoat;